import DataStore from '../store';
export const checkFeatureFieldEnabled = (feature: string, field: string) => {
  const groupConfig = DataStore.config?.pages;
  if (!groupConfig) {
    return false;
  }
  if (feature.indexOf('_') !== -1) {
    const [group, subFeature] = feature.split('_');
    const featureConfig = groupConfig[group];

    if (!featureConfig) {
      return false;
    }

    return featureConfig.settings?.[subFeature]?.[field] || false;
  }
  const featureConfig = groupConfig[feature];
  if (!featureConfig) {
    return false;
  }

  return featureConfig.settings?.[field] || false;
};

export const getAllKeysForFeature = (feature: string) => {
  const groupConfig = DataStore.config?.pages;
  if (!groupConfig) {
    return [];
  }

  const featureConfig = groupConfig[feature];
  if (!featureConfig) {
    return [];
  }

  return Object.keys(featureConfig.settings || {});
};
